import { connectLocation } from "../../location/LocationConnectors";
import Reusable from "../../OC/PageBuilder/Reusable";

// just a short code-saver. almost every time we drop in a reusable, we connect it to the provider's locale.code
const ConnectedReusable = connectLocation(({ name, path, locale: { code: localeCode }, ...props }) => (
  <Reusable language={localeCode} name={name} path={path} {...props} />)
)

export default ConnectedReusable
